export const brandMarkPath = "/brand/logo.svg";
export const brandVectorLogoPath = "/brand/logo.svg";

// Backward-compatible alias for existing public/app shell consumers.
export const brandLogoPath = brandMarkPath;

type BrandLockupProps = {
  label?: string;
  href?: string;
  className?: string;
  pills?: string[];
};

export function BrandLockup({
  label,
  href = "/",
  className,
  pills
}: BrandLockupProps) {
  return (
    <a className={className ?? "nav-brand"} href={href} aria-label={label ?? "THH"}>
      <img className="brand-logo" src={brandMarkPath} alt="" aria-hidden="true" />
      {label ? <span className="nav-wordmark">{label}</span> : null}
      {pills?.map((pill) => (
        <span key={pill} className="nav-pill">{pill}</span>
      ))}
    </a>
  );
}
